// SaleTab.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FilterControls,
  SummaryCard,
  OrderTable,
  WarehouseSummary,
  WarehouseTables,
  getMaterialTypes,
  getFilteredOrders,
  calculateTotals,
  separateByPlace,
} from '../../Component/SharedComponents';

const SaleTab = ({ orders, date, setDate, onViewDetail, allData }) => {
  const [materialFilter, setMaterialFilter] = useState('all');

  const materialTypes = getMaterialTypes(orders);
  const filteredOrders = getFilteredOrders(orders, materialFilter);
  const totals = calculateTotals(filteredOrders);

  const { oldWarehouse, newWarehouse, otherWarehouse } =
    separateByPlace(filteredOrders);
  //console.log('sale', orders);

  return (
    <>
      <FilterControls
        materialTypes={materialTypes}
        currentFilter={materialFilter}
        setFilter={setMaterialFilter}
        date={date}
        setDate={setDate}
      />

      <WarehouseSummary
        oldWarehouseOrders={oldWarehouse}
        newWarehouseOrders={newWarehouse}
        otherWarehouseOrders={otherWarehouse}
        type="SALE"
      />

      <WarehouseTables
        oldWarehouseOrders={oldWarehouse}
        newWarehouseOrders={newWarehouse}
        otherWarehouseOrders={otherWarehouse}
        onViewDetail={onViewDetail}
        allData={allData}
      />
    </>
  );
};

SaleTab.propTypes = {
  orders: PropTypes.array,
  date: PropTypes.string.isRequired,
  setDate: PropTypes.func.isRequired,
  onViewDetail: PropTypes.func.isRequired,
};

SaleTab.defaultProps = {
  orders: [],
};

export default SaleTab;
